<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table1"
        title="방지시설 보수내역"
        tableId="table1"
        :columns="grid1.columns"
        :gridHeight="grid1.height"
        :data="grid1.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" icon="save" v-if="!param.isFullScreen" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'daily-air-report-03',
  props: {
    param: {
      type: Object,
      default: () => ({
        reportId: '',
        isFullScreen: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid1: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '방지시설명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '배출구명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '보수기간',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '보수자',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '보수명세',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
    if (this.param.isFullScreen) {
      this.grid1.height = 'auto';
    }
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.grid1.data = [
        {
          col0: '방지시설2',
          col1: '2021-01-02 ~ 2021-02-01',
          col2: '관리자',
          col3: '',
          col4: '배출구1',
        },
        {
          col0: '방지시설3',
          col1: '2021-01-02 ~ 2021-02-01',
          col2: '환경팀원',
          col3: '',
          col4: '배출구2',
        },
      ]
    },
  }
};
</script>
